module.exports = __webpack_public_path__ + "static/media/bg3.cc0080fc.webp";